import React from 'react';

export const useAnalytics = (module: string = '') => {
  // todo configure application insights
  return React.useMemo(() => ({
    log: {
      error(message: string, stack?: any){
        window.console.error(`${module} ${message}`, stack);
      }
    }
  }), [module]);
}